import React, { Component, createContext, createRef } from 'react';
import $ from 'jquery';
import './styles/search_tour_form.scss';
import ProgressBar from '@ramonak/react-progress-bar';
import { FaStar, FaHotel } from 'react-icons/fa';
import { PiAirplaneTakeoffLight } from 'react-icons/pi';
import { AiOutlineApi, AiOutlineInfoCircle } from 'react-icons/ai';
import { MdOutlineYoutubeSearchedFor } from 'react-icons/md';

import DepartCity from './components/DepartCity';
import DestinationCountry from './components/DestinationCountry';
import Dates from './components/Dates';
import Nights from './components/Nights';
import Peoples from './components/Peoples';
import Stars from './components/Stars';
import Meals from './components/Meals';
import Operator from './components/Operator';
import Regions from './components/Regions';
import Services from './components/Services';
import Promo from './components/Promo';
import Hotels from './components/Hotels';
import Rating from './components/Rating';
import Races from './components/Races';
import FastBooking from './components/FastBooking';
import Price from './components/Price';
import SearchTourButton from './components/SearchTourButton';
import SearchTourMoreButton from './components/SearchTourMoreButton';
import GeoclientBar from './components/Geoclient/GeoclientBar';
import HotelInfoView from './views/HotelInfoView';

import HOTEL_RATING_MAP from './constants/HatelRatingMap';
import DEPART_CITY_DIC from './constants/DepartCity';
import COUNTRY_DIC from './constants/DestinationCountry';

import requestModel from '../../entities/requestModel';

import tourvisorAPI from '../api/tourvisorAPI';
import { GeoclientApi } from '../api/GeoclientApi';
import SearchNotification from '../../shared/components/SearchNotification';
import TouroperatorFilter from '../../shared/components/TouroperatorFilter';
import HotelList from './components/HotelList';
import geograftourAPI from '../api/geograftourAPI';
import axios from 'axios';
import HasReviews from './components/HasReviews';

const TOUR_SEARCH_INTERVAL = 2000;
const TOUR_SEARCH_TIMES_LIMIT = 200;
const tour_search_counter = {};

const COUNTRY_RANK_DIC = {
  0: 'Топовые страны',
  1: 'Популярные страны',
  2: 'Остальные страны',
};

const TOURS = [];
let autosearch = false;

export const GeoclientContext = createContext();

class SearchTourForm extends Component {
  constructor(props) {
    super(props);

    this.handleSearch = this.handleSearch.bind(this);
    this.handleContinue = this.handleContinue.bind(this);

    this.setDepart = this.setDepart.bind(this);
    this.setCountry = this.setCountry.bind(this);
    this.setMeal = this.setMeal.bind(this);
    this.setOperators = this.setOperators.bind(this);
    this.setRegions = this.setRegions.bind(this);
    this.setSubRegions = this.setSubRegions.bind(this);
    this.setServices = this.setServices.bind(this);
    this.setActypes = this.setActypes.bind(this);
    this.setHotels = this.setHotels.bind(this);
    this.resetHotels = this.resetHotels.bind(this);
    this.setStars = this.setStars.bind(this);
    this.setRating = this.setRating.bind(this);
    this.setRaces = this.setRaces.bind(this);
    this.setPromo = this.setPromo.bind(this);
    this.setDates = this.setDates.bind(this);
    this.setNights = this.setNights.bind(this);
    this.setPrice = this.setPrice.bind(this);
    this.setPeoples = this.setPeoples.bind(this);
    this.setFastBooking = this.setFastBooking.bind(this);
    this.setRecomendHotels = this.setRecomendHotels.bind(this);
    this.setHotelsIdWithReviews = this.setHotelsIdWithReviews.bind(this);
    this.handleHasReviews = this.handleHasReviews.bind(this);
    this.handleRecomend = this.handleRecomend.bind(this);
    this.handleHideTouroperator = this.handleHideTouroperator.bind(this);
    this._handleFlightTypeChange = this._handleFlightTypeChange.bind(this);
    this.setFilterOperators = this.setFilterOperators.bind(this);

    this.handleGeoclientUpdate = this.handleGeoclientUpdate.bind(this);
    this.handleGeoclientRemoveTour = this.handleGeoclientRemoveTour.bind(this);
    this.handleGeoclientReset = this.handleGeoclientReset.bind(this);
    this.handleGeoclientOnAuth = this.handleGeoclientOnAuth.bind(this);
    this.authentificate = this.authentificate.bind(this);
    this.checkAuthentificate = this.checkAuthentificate.bind(this);
    this.refreshToken = this.refreshToken.bind(this);
    this.handleLogout = this.handleLogout.bind(this);
    this.handleQuoteEdit = this.handleQuoteEdit.bind(this);
    this.handleQuoteEditCancel = this.handleQuoteEditCancel.bind(this);
    this.changeEditStatus = this.changeEditStatus.bind(this);
    this.getQuotes = this.getQuotes.bind(this);

    this.toggleHotelPopup = this.toggleHotelPopup.bind(this);
    this.getHotelInfo = this.getHotelInfo.bind(this);
    this.toggleHotelInfoLoading = this.toggleHotelInfoLoading.bind(this);
    this.setHotelData = this.setHotelData.bind(this);
    this.handleSearchError = this.handleSearchError.bind(this);
    this.restartSearchWithNewRequest =
      this.restartSearchWithNewRequest.bind(this);
    this.controllerRef = createRef();
    this.checkTourRequestTimeoutRef = createRef();

    this.fieldsToKeep = [
      'tour_id',
      'country',
      'city_from',
      'checkin',
      'nights',
      'adults',
      'children',
      'child_ages',
      'resort',
      'name',
      'thumbnail',
      'operator',
      'room',
      'board',
      'initial_price',
      'currency',
      'is_active',
      'manager_data',
      'comment',
      'discount',
      'manager_id',
    ];

    this.toursRef = React.createRef();
    this.state = {
      hotels: {},
      moreButton: false,
      request: requestModel,
      hotelsOnPage: 200,
      flightTypeChange: false,
      response: {
        data: {
          result: {
            hotel: [],
          },
        },
      },
      searchErrorText: '',
      searchError: false,
      stopSearchNotification: false,
      request_id: null,
      tour_request: null,
      is_mobile: false,
      geoclient: {
        tours: TOURS,
        quotes: [],
        isAuth: false,
        user: null,
        token: null,
        isQuotesLoaded: false,
        isQuotesLoading: false,
      },
      recomend_hotels: [],
      showHotelInfo: true,
      startSearch: false,
      isSearching: false,
      wasSearching: false,
      isQuoteEdit: false,
      isHotelPopupOpened: false,
      hotelDetails: {},
      isHotelInfoLoading: false,
      requestedDeparture: null,
      filteredOperators: [],
      hotelId: '',
      hotelData: '',
      hotelsIdWithReviews: [],
      hotelsInfoWithReviews: [],
      hotelPopupTabNumber: 0,
      hasReviews: false,
    };
    if (props.DEPART_DATA) {
      this.state.request.departure = this.props.DEPART_DATA.id;
      if (props.DEPART_DATA.country_id == 78) {
        this.state.request.currency = 3;
      }
    }
  }

  handleHideTouroperator(hideoperator) {
    this.setState({
      request: {
        ...this.state.request,
        hideoperator,
      },
    });
  }

  handleGeoclientUpdate() {
    this.setState({
      geoclient: {
        ...this.state.geoclient,
        tours: JSON.parse(localStorage.getItem('tourStack')),
      },
    });
  }

  handleGeoclientReset() {
    localStorage.setItem('tourStack', JSON.stringify([]));
    this.setState({
      geoclient: {
        ...this.state.geoclient,
        tours: [],
      },
    });
  }

  handleGeoclientOnAuth(isAuth, user = null, token) {
    const self = this;
    this.setState(
      {
        geoclient: {
          ...this.state.geoclient,
          isAuth: isAuth,
          user: user,
          token: token,
        },
      },
      () => {
        self.setState({
          geoclient: {
            ...this.state.geoclient,
            isQuotesLoading: true,
          },
        });
        if (this.state.geoclient.isAuth) {
          if (this.state.geoclient.token) {
            this.getQuotes();
          }
        }
      }
    );
  }

  getQuotes() {
    this.setState({
      geoclient: {
        ...this.state.geoclient,
        isQuotesLoading: true,
        isQuotesLoaded: false,
      },
    });
    GeoclientApi.getQuotes(this.state.geoclient.token).then((res) => {
      this.setState({
        geoclient: {
          ...this.state.geoclient,
          quotes: res.response.results,
          isQuotesLoading: false,
          isQuotesLoaded: true,
        },
      });
    });
  }

  handleGeoclientRemoveTour(id) {
    const tour_id = id;
    const tourList = JSON.parse(localStorage.getItem('tourStack'));
    const newTourList = tourList.filter(function (item) {
      return item.tour_id != tour_id;
    });
    localStorage.setItem('tourStack', JSON.stringify(newTourList));
    this.setState({
      geoclient: {
        ...this.state.geoclient,
        tours: newTourList,
      },
    });
  }

  /**
   * Нормализация выгруженных туров
   * @param {*} data
   *
   */

  async _checkTourRequest(request) {
    this.controllerRef = new AbortController();
    var request_id = request.requestid || this.response.data.status.requestid,
      tour_count = request.tour_count,
      page = request.page || 0,
      onpage = request.onpage || this.state.hotelsOnPage;

    console.log('SearchTourForm -> _checkTourRequest -> onpage', onpage);
    const signal = this.controllerRef.signal;
    let response;
    try {
      response = await tourvisorAPI.result(request_id, onpage, page, signal);
      const progressPrev = this.state.response.data.status.progress;
      this.setState({
        response: response,
        progressPrev: progressPrev,
      });
      let search_status = (response.data && response.data.status) || {},
        result = response;

      if (response.data && response.data.result) {
        let hotels = this.state.hotels;
        hotels[0] = response.data.result.hotel;
        this.setState({ hotels, moreButton: true });
      } else {
        this.setState({ moreButton: false });
      }

      if (
        search_status.state === 'finished' ||
        result.length >= tour_count ||
        tour_search_counter[request_id] > TOUR_SEARCH_TIMES_LIMIT
      ) {
        this.setState({ isSearching: false });
        // Туров достаточно или превышен лимит по количеству запросов => возвращаем полученный результат
        if (!search_status.toursfound && this.state.request.hideregular) {
          this.setState(
            {
              request: {
                ...this.state.request,
                hideregular: 0,
              },
            },
            () => this.handleSearch()
          );
          this._handleFlightTypeChange();
        }
        if (search_status.hotelsfound > onpage) {
          console.log(
            'SearchTourForm -> _checkTourRequest -> INCREASE this.state.hotelsOnPage!'
          );
          this.setState((prevState) => ({
            hotelsOnPage: prevState.hotelsOnPage + onpage,
          }));
        }
      } else if (search_status.state === 'no search results') {
      } else {
        // Посылаем повторный запрос через TOUR_SEARCH_INTERVAL мс
        tour_search_counter[request_id] += 1;
        this.checkTourRequestTimeoutRef = setTimeout(() => {
          this._checkTourRequest(request);
        }, TOUR_SEARCH_INTERVAL);
      }
    } catch (err) {
      if (axios.isCancel(err)) {
        console.log('Запрос был отменен');
      }
    }
  }

  _handleFlightTypeChange() {
    this.setState({ flightTypeChange: true });
    setTimeout(() => {
      this.setState({ flightTypeChange: false });
    }, 5000);
  }

  _parseSearchResponse(request, response) {
    console.log('parse search response');
    const tour_request = {
        tour_count: request.tour_count || this.state.hotelsOnPage,
      },
      request_id = response && response.result && response.result.requestid;

    if (!request_id) {
      this.setState({
        request: request,
        response: response,
        startSearch: false,
      });
      /* Не найден request_id в ответе, пытаемся сразу выдать туры */
      return;
    }

    if (request.departure) {
      tour_request.departure = request.departure;
    }
    if (request.priceonly) {
      tour_request.priceonly = request.priceonly;
    }
    tour_request.requestid = request_id;
    tour_search_counter[request_id] = 0;
    this.setState({
      tour_request,
      request_id,
      startSearch: false,
      hotels: [],
      wasSearching: true,
    });
    if (response.progress === 100 || response.status === 'finished') {
      this.setState({ isSearching: false });
    }
    this.checkTourRequestTimeoutRef = setTimeout(() => {
      this._checkTourRequest(tour_request);
    }, TOUR_SEARCH_INTERVAL);
  }

  async handleSearch(auto = false) {
    this.setState({
      isSearching: true,
      requestedDeparture: this.state.request.departure,
      response: {
        data: {
          status: { progress: 5 },
          result: {
            hotel: [],
          },
        },
      },
      filteredOperators: [],
    });

    console.log('handle search');
    const { request } = this.state;
    if (request.ages.length) {
      request.ages.forEach((age, idx) => {
        request[`childage${idx + 1}`] = age;
      });
    }
    if (request.subregions.length) {
      request.regions = [];
    }
    if (request.hotels.includes(2)) {
      let index = request.hotels.indexOf(2);
      if (index !== -1) {
        request.hotels.splice(index, 1);
      }
    }
    if (auto) {
      request.timestamp = Date.now();
    }
    if (request.actypes) {
      const correctActypes = request.actypes.map((actype) => {
        return actype.replace(9, '');
      });
      request.actypes = correctActypes;
    }
    this.setState({
      startSearch: true,
    });
    let requestQuery = new URLSearchParams(request).toString();
    const res = await tourvisorAPI.search(requestQuery);

    if (!res.error) {
      this._parseSearchResponse(request, res);
    } else {
      this.handleSearchError(res);
    }
  }

  handleSearchError(res) {
    const { error, errormessage } = res;
    this.setState({
      response: { data: { status: { progress: 100, status: 'finished' } } },
      searchErrorText: errormessage || "Наблюдаются проблемы в работе поиска, попробуйте еще раз позднее",
      searchError: error,
      startSearch: false,
    });
  }

  handleRecomend(recomend_hotels) {
    this.setState({ recomend_hotels });
  }

  handleHasReviews(hasReviews) {
    this.resetHotels();
    this.setState({ hasReviews });
  }

  async handleContinue() {
    this.setState({
      response: { data: { status: { progress: 5 } } },
      filteredOperators: [],
    });

    console.log('SearchTourForm -> handleContinue');
    const rid =
      this.state.request_id || this.state.response.data.status.requestid;
    // const res = await tourvisorAPI.continue(rid);
    // const page = res && res.result && res.result.page ? res.result.page : 0;
    if (this.state.tour_request) {
      this._checkTourRequest({ ...this.state.tour_request, page: 'continue' });
    } else {
      this._checkTourRequest({
        ...this.state.request,
        requestid: rid,
        page: 'continue',
      });
    }
  }

  setDepart(value) {
    console.log(
      'установить город по умолчанию',
      value,
      this.state.request.departure,
      DEPART_CITY_DIC[value].country_id
    );
    let currency = 0;
    if (DEPART_CITY_DIC[value].country_id == 78) {
      currency = 3;
    }
    this.setState(
      {
        request: {
          ...this.state.request,
          departure: value,
          currency: currency,
        },
      },
      () => console.log('вылет', this.state.request.departure)
    );
  }

  setMeal(meal) {
    this.setState({
      request: {
        ...this.state.request,
        meal,
      },
    });
  }

  setCountry(value) {
    this.setState({
      request: {
        ...this.state.request,
        country: value,
        regions: [],
        subregions: [],
        hotels: [],
        recomend: false,
      },
      hasReviews: false,
    });
  }

  setOperators(operators) {
    this.setState({
      request: {
        ...this.state.request,
        operators,
      },
    });
  }

  setRegions(regions) {
    this.setState((prevState) => ({
      request: {
        ...prevState.request,
        regions,
      },
    }));
  }

  setSubRegions(subregions) {
    this.setState({
      request: {
        ...this.state.request,
        subregions,
      },
    });
  }

  setServices(services) {
    this.setState({
      request: {
        ...this.state.request,
        services,
      },
    });
  }

  setActypes(actypes) {
    this.setState({
      request: {
        ...this.state.request,
        actypes,
      },
    });
  }

  setPromo(promo) {
    this.setState({
      request: {
        ...this.state.request,
        promo,
      },
    });
  }

  setRating(value) {
    this.setState({
      request: {
        ...this.state.request,
        rating: value,
        dictRating:
          Number(value) === 0
            ? HOTEL_RATING_MAP[value].rating
            : HOTEL_RATING_MAP[value - 1].rating,
      },
    });
  }

  setStars(stars) {
    this.setState({
      request: {
        ...this.state.request,
        stars,
      },
    });
  }

  setRaces(hideregular) {
    this.setState({
      request: {
        ...this.state.request,
        hideregular,
      },
    });
  }

  setHotels(hotels) {
    this.setState({
      request: {
        ...this.state.request,
        hotels,
      },
    });
  }

  resetHotels() {
    this.setState((prevState) => ({
      request: {
        ...prevState.request,
        hotels: [],
        recomend: false,
      },
      hasReviews: false,
    }));
  }

  setPrice({ priceto, pricefrom, currency }) {
    this.setState({
      request: {
        ...this.state.request,
        priceto,
        pricefrom,
        currency,
      },
    });
  }

  setDates(dates) {
    if (typeof dates == 'boolean') {
      this.setRaces(dates ? 1 : 0);
      return;
    }
    this.setState({
      request: {
        ...this.state.request,
        dateto: dates.dateto,
        datefrom: dates.datefrom,
      },
    });
  }

  setNights(nightsfrom, nightsto) {
    this.setState({
      request: {
        ...this.state.request,
        nightsfrom,
        nightsto,
      },
    });
  }

  setPeoples(params) {
    this.setState({
      request: {
        ...this.state.request,
        adults: params.adults,
        child: params.kids,
        ages: params.ages,
      },
    });
  }

  setFastBooking(isCheck) {
    if (isCheck) {
      this.setState({
        request: {
          ...this.state.request,
          services: [...this.state.request.services, 46],
        },
      });
    }
  }

  setRecomendHotels(recomend) {
    this.setState({
      request: {
        ...this.state.request,
        recomend,
      },
      hasReviews: false,
    });
  }

  setFilterOperators(operators) {
    this.setState({
      filteredOperators: operators,
    });
  }

  authentificate() {
    const self = this;
    const [login, password] = JSON.parse(localStorage.getItem('remember'));
    const form = new FormData();
    form.append('login', login);
    form.append('password', password);
    GeoclientApi.login(form).then((result) => {
      if (result.auth) {
        self.setState({
          geoclient: {
            ...self.state.geoclient,
            isAuth: result.auth,
            user: result.user,
            token: result.token,
          },
        });
      }
    });
  }

  checkAuthentificate(accessToken) {
    GeoclientApi.getQuotes(accessToken).then((res) => {
      if (res.user.id) {
        this.setState({
          geoclient: {
            ...this.state.geoclient,
            isAuth: true,
            user: res.user,
            token: accessToken,
            isQuotesLoaded: true,
            isQuotesLoading: false,
            quotes: res.quotes,
          },
        });
      } else {
        this.refreshToken();
      }
    });
  }

  refreshToken() {
    const refreshToken = localStorage.getItem('refresh');
    if (refreshToken) {
      GeoclientApi.updateToken(refreshToken).then((res) => {
        if (res.auth) {
          this.checkAuthentificate(res.token);
          localStorage.setItem('token', res.token);
        } else console.log('Нужна повторная авторизация');
      });
    } else console.log('Нужна повторная авторизация');
  }

  handleLogout() {
    this.setState({
      geoclient: {
        quotes: [],
        isAuth: false,
        user: null,
        token: null,
        isQuotesLoaded: false,
        isQuotesLoading: false,
      },
    });
  }

  _cleanData(obj, fieldsToKeep) {
    const cleanedObj = {};
    Object.keys(obj).forEach((key) => {
      if (fieldsToKeep.includes(key)) {
        if (typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
          cleanedObj[key] = this._cleanData(obj[key], fieldsToKeep);
        } else {
          cleanedObj[key] = obj[key];
        }
      }
    });
    return cleanedObj;
  }

  handleQuoteEdit = async (quoteId) => {
    localStorage.setItem('quoteId', quoteId);

    this.getQuoteInfo(quoteId)
      .then((data) => {
        const dirtyTours = data.response.tours;
        const quoteTitle = data.response.title;
        let cleanTours = [];
        dirtyTours.forEach((tour) => {
          cleanTours.push(this._cleanData(tour, this.fieldsToKeep));
        });
        localStorage.setItem('quoteTitle', quoteTitle);
        localStorage.setItem('tourStack', JSON.stringify(cleanTours));
        this.changeEditStatus(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  getQuoteInfo = async (quoteId) => {
    let token = localStorage.getItem('token');
    try {
      const data = await GeoclientApi.getQuote(token, quoteId);
      return data;
    } catch (err) {
      console.log(err);
      return err;
    }
  };

  handleQuoteEditCancel() {
    this.changeEditStatus(false);
    localStorage.setItem('tourStack', JSON.stringify([]));
    localStorage.removeItem('quoteId');
    localStorage.removeItem('quoteTitle');
  }

  changeEditStatus(status) {
    this.setState({ isQuoteEdit: status });
  }

  toggleHotelPopup(e) {
    const { classList, nodeName } = e.target;
    if (
      classList.value === 'hotel-popup hotel-popup__opened' ||
      classList.value === 'hotel-popup__close-btn' ||
      nodeName === 'path'
    ) {
      this.setState({ isHotelPopupOpened: !this.state.isHotelPopupOpened });
    }
  }

  toggleHotelInfoLoading() {
    this.setState({ isHotelInfoLoading: !this.state.isHotelInfoLoading });
  }

  setHotelData(hotelData, hotelId) {
    this.setState({ hotelData, hotelId });
  }

  getHotelInfo = async (hotelId, hotelPopupTabNumber = 0) => {
    if (hotelId === this.state.hotelId) {
      this.setState({ isHotelPopupOpened: true, hotelPopupTabNumber });
    } else {
      const { data } = await tourvisorAPI.getHotelInfo(hotelId);
      if (data.hotel) {
        this.setHotelData(data.hotel, hotelId);
        this.setState({ isHotelPopupOpened: true, hotelPopupTabNumber });
      }
    }
  };

  restartSearchWithNewRequest() {
    if (this.controllerRef) {
      this.setState({
        stopSearchNotification: true,
        isSearching: false,
      });
      setTimeout(() => {
        this.setState({ stopSearchNotification: false });
      }, 2000);
      this.controllerRef.abort();
      if (this.checkTourRequestTimeoutRef) {
        clearTimeout(this.checkTourRequestTimeoutRef);
      }
      this.setState(
        {
          response: {
            data: {
              status: { progress: 100 },
            },
          },
          moreButton: false,
        },
        () => {
          this.handleSearch();
        }
      );
    }
  }

  setHotelsIdWithReviews() {
    geograftourAPI
      .getHotelsWithReviews(this.state.request.country)
      .then((res) => {
        const hotelsId = res.map((hotel) => hotel.tourvisor_id.toString());
        this.setState({
          hotelsIdWithReviews: hotelsId,
          hotelsInfoWithReviews: res,
        });
      });
  }

  componentDidMount() {
    localStorage.removeItem('officeId');
    this.setHotelsIdWithReviews();
    const isMobile = () =>
      /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    if (isMobile()) {
      this.setState({
        is_mobile: isMobile(),
      });
    }
    const handleResize = () => {
      if (isMobile()) {
        this.setState({
          is_mobile: isMobile(),
        });
      }
    };
    if (this.props.DEPART_DATA) {
      this.setDepart(this.props.DEPART_DATA.id);
    }

    if (localStorage.getItem('token')) {
      this.checkAuthentificate(localStorage.getItem('token'));
    }

    window.addEventListener('resize', handleResize);
    this.setDates({
      datefrom: this.state.request.datefrom,
      dateto: this.state.request.dateto,
    });
    if (autosearch) {
      this.handleSearch(true);
      autosearch = false;
    }
    sessionStorage.setItem('geoclient', 1);
  }

  render() {
    const {
      departure,
      country,
      datefrom,
      dateto,
      nightsfrom,
      nightsto,
      stars,
      adults,
      child,
      meal,
      hotels,
      pricefrom,
      priceto,
      currency,
      operators,
      regions,
      subregions,
      services,
      rating,
      hideregular,
      promo,
      recomend,
      dictRating,
      actypes,
      hideoperator,
    } = this.state.request;
    const { data } = this.state.response;
    const {
      showHotelInfo,
      recomend_hotels,
      isHotelPopupOpened,
      hotelData,
      isHotelInfoLoading,
      response,
      is_mobile,
      flightTypeChange,
      searchErrorText,
      searchError,
      stopSearchNotification,
      filteredOperators,
      hotelId,
      hotelsIdWithReviews,
      hotelPopupTabNumber,
      isSearching,
      hasReviews,
    } = this.state;
    let hotelsForView = [];
    for (var page in this.state.hotels) {
      hotelsForView.push(...this.state.hotels[page]);
    }

    const CountrySorted = Object.values(COUNTRY_DIC)
      .map(function (item) {
        return {
          id: item.id,
          value: item.id,
          label: item.name,
          name: item.name,
          code: item.code,
          url: item.url,
          rank: item.rank,
          sort: item.rank.toString() + '_' + item.name,
          category: COUNTRY_RANK_DIC[item.rank],
        };
      })
      .sort(function (a, b) {
        if (a.name < b.name) return -1;
        if (a.name > b.name) return 1;
        return 0;
      });

    return (
      <GeoclientContext.Provider value={this.state.geoclient}>
        <HotelInfoView
          isHotelInfoLoading={isHotelInfoLoading}
          isHotelPopupOpened={isHotelPopupOpened}
          toggleHotelPopup={this.toggleHotelPopup}
          hotel={hotelData}
          hotelId={hotelId}
          hotelPopupTabNumber={hotelPopupTabNumber}
        />
        <GeoclientBar
          tours={this.state.geoclient.tours}
          user={this.state.geoclient.user}
          isQuotesLoaded={this.state.isQuotesLoaded}
          quotes={this.state.geoclient.quotes}
          isAuth={this.state.geoclient.isAuth}
          token={this.state.geoclient.token}
          isQuoteEdit={this.state.isQuoteEdit}
          onAuth={this.handleGeoclientOnAuth}
          onUpdate={this.handleGeoclientUpdate}
          onReset={this.handleGeoclientReset}
          onRemove={this.handleGeoclientRemoveTour}
          progress={data?.status?.progress}
          getQuoteInfo={this.getQuoteInfo}
          handleQuoteEdit={this.handleQuoteEdit}
          handleQuoteEditCancel={this.handleQuoteEditCancel}
          changeEditStatus={this.changeEditStatus}
          handleLogout={this.handleLogout}
        />
        <h2
          className="search__title"
          style={{
            textAlign: 'center',
            fontSize: '20px',
            fontWeight: 700,
            marginBottom: '12px',
            color: '#3D87C8',
          }}
        >
          ПОИСК ТУРА ПО ВСЕМ ТУРОПЕРАТОРАМ ДЛЯ АГЕНТСТВ
        </h2>
        {!this.state.is_mobile ? (
          <div className="search-tour-form search-tour-form__agency-new container">
            <div className="flex-wrapper">
              <DepartCity
                value={departure}
                onChoose={this.setDepart}
                dictionary={DEPART_CITY_DIC}
              />
              <DestinationCountry
                value={country}
                depart={departure}
                currency={currency}
                onChoose={this.setCountry}
                items={CountrySorted}
                dictionary={COUNTRY_DIC}
              />
              <Dates
                datefrom={datefrom}
                dateto={dateto}
                departure={this.state.request.departure}
                country={country}
                currency={currency}
                onChoose={this.setDates}
                hideregular={hideregular}
                onChangeRegular={this.setRaces}
                is_mobile={is_mobile}
              />
              <Nights
                value={[nightsfrom, nightsto]}
                onChoose={this.setNights}
              />
              <Peoples
                adults={adults}
                kids={child}
                onChoose={this.setPeoples}
              />
            </div>
            <div className="flex-wrapper">
              <Stars value={stars} onChoose={this.setStars} />
              <HasReviews
                hasReviews={hasReviews}
                onFilter={this.handleHasReviews}
              />
              <Meals value={meal} onChoose={this.setMeal} />
              <Rating value={rating} onChoose={this.setRating} />
              <Services
                valueServices={services}
                valueActypes={actypes}
                onChooseServices={this.setServices}
                onChooseActypes={this.setActypes}
              />
            </div>
            <div className="flex-wrapper">
              <Regions
                value={regions}
                subvalue={subregions}
                country={country}
                onChoose={this.setRegions}
                onSubChoose={this.setSubRegions}
              />
              <Hotels
                value={hotels}
                country={country}
                stars={stars}
                regions={regions}
                subregions={subregions}
                recomend={recomend}
                onRecomend={this.handleRecomend}
                rating={dictRating}
                onChoose={this.setHotels}
                onReset={this.resetHotels}
                onSetRating={this.setRating}
                onSetRecommend={this.setRecomendHotels}
                hasReviews={hasReviews}
                onSetWithReviews={this.handleHasReviews}
                hotelsIdWithReviews={hotelsIdWithReviews}
                setHotelsIdWithReviews={this.setHotelsIdWithReviews}
              />
              <Operator
                value={operators}
                country={country}
                onHide={this.handleHideTouroperator}
                onChoose={this.setOperators}
              />
            </div>
            <div className="flex-wrapper mb-0">
              <Price
                pricefrom={pricefrom}
                priceto={priceto}
                currency={currency}
                onChoose={this.setPrice}
              />
              <Promo value={promo} onChoose={this.setPromo} />
              <Races value={hideregular} onChoose={this.setRaces} />
              <FastBooking value={services} onChoose={this.setServices} />
              <SearchTourButton
                onSearch={
                  isSearching
                    ? this.restartSearchWithNewRequest
                    : this.handleSearch
                }
              />
            </div>
          </div>
        ) : (
          <div className="search-tour-form search-tour-form__agency-new search-tour-form__agency-new--mobile">
            <div className="flex-wrapper">
              <DepartCity
                value={departure}
                onChoose={this.setDepart}
                dictionary={DEPART_CITY_DIC}
              />
              <DestinationCountry
                value={country}
                depart={departure}
                currency={currency}
                onChoose={this.setCountry}
                items={CountrySorted}
                dictionary={COUNTRY_DIC}
              />
            </div>
            <div className="flex-wrapper">
              <Dates
                datefrom={datefrom}
                dateto={dateto}
                departure={this.state.request.departure}
                country={country}
                currency={currency}
                onChoose={this.setDates}
                hideregular={hideregular}
                onChangeRegular={this.setRaces}
                is_mobile={is_mobile}
              />
              <Nights
                value={[nightsfrom, nightsto]}
                onChoose={this.setNights}
              />
            </div>
            <div className="flex-wrapper">
              <Peoples
                adults={adults}
                kids={child}
                onChoose={this.setPeoples}
              />
              <Regions
                isOpen={false}
                value={regions}
                subvalue={subregions}
                onSubChoose={this.setSubRegions}
                country={country}
                onChoose={this.setRegions}
              />
            </div>
            <div className="flex-wrapper">
              <Stars value={stars} onChoose={this.setStars} />
              <Meals value={meal} onChoose={this.setMeal} />
            </div>
            <div className="flex-wrapper hotel">
              <Hotels
                isOpen={false}
                value={hotels}
                country={country}
                stars={stars}
                regions={regions}
                subregions={subregions}
                recomend={recomend}
                onRecomend={this.handleRecomend}
                rating={dictRating}
                onChoose={this.setHotels}
                onReset={this.resetHotels}
                onSetRating={this.setRating}
                hasReviews={hasReviews}
                onSetRecommend={this.setRecomendHotels}
                onSetWithReviews={this.handleHasReviews}
                hotelsIdWithReviews={hotelsIdWithReviews}
                setHotelsIdWithReviews={this.setHotelsIdWithReviews}
              />
            </div>
            <div className="flex-wrapper">
              <Rating value={rating} onChoose={this.setRating} />
              <Services
                valueServices={services}
                valueActypes={actypes}
                onChooseServices={this.setServices}
                onChooseActypes={this.setActypes}
              />
            </div>
            <div className="flex-wrapper">
              <Promo value={promo} onChoose={this.setPromo} />
              <Operator
                isOpen={false}
                value={operators}
                country={country}
                onChoose={this.setOperators}
                isOperatorHidden={hideoperator}
                onHide={this.handleHideTouroperator}
              />
            </div>
            <div className="flex-wrapper">
              <FastBooking value={services} onChoose={this.setServices} />
              <Races value={hideregular} onChoose={this.setRaces} />
            </div>
            <div className="flex-wrapper">
              <Price
                pricefrom={pricefrom}
                priceto={priceto}
                onChoose={this.setPrice}
              />
              <SearchTourButton
                onSearch={
                  isSearching
                    ? this.restartSearchWithNewRequest
                    : this.handleSearch
                }
              />
            </div>
          </div>
        )}
        {data && data.status && (
          <div className="result container" style={{ display: 'block' }}>
            {(data?.status?.progress !== 100) & !response.expire ? (
              <div style={{ padding: '20px' }}>
                <ProgressBar
                  bgColor={'#DE4596'}
                  completed={data.status.progress}
                />
              </div>
            ) : null}
            <div className="search__info">
              {data.status.operators ? (
                <TouroperatorFilter
                  data={data}
                  onChoose={this.setFilterOperators}
                >
                  <div className="search__point">
                    <FaHotel className="search__point-icon" />
                    <div className="search__point-text">
                      Найдено отелей:
                      {data.status.hotelsfound ? (
                        <>
                          <b>{data.status.hotelsfound}</b>
                          {isSearching ? (
                            <div className="loading-rotator"></div>
                          ) : null}
                        </>
                      ) : (
                        <>
                          {isSearching ? (
                            <div className="loading-rotator"></div>
                          ) : (
                            <b>0</b>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                  <div className="search__point">
                    <FaStar className="search__point-icon" />
                    <div className="search__point-text">
                      Найдено туров:
                      {data.status.toursfound ? (
                        <>
                          <b>{data.status.toursfound}</b>
                          {isSearching ? (
                            <div className="loading-rotator"></div>
                          ) : null}
                        </>
                      ) : (
                        <>
                          {isSearching ? (
                            <div className="loading-rotator"></div>
                          ) : (
                            <b>0</b>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                </TouroperatorFilter>
              ) : null}
            </div>
            {data.status.toursfound === 0 &&
            this.state.wasSearching &&
            data.status.progress === 100 ? (
              <SearchNotification
                cssClass="search__message_no-tours"
                message={'Туры не найдены, измените критерии поиска'}
              >
                <AiOutlineInfoCircle />
              </SearchNotification>
            ) : null}
            <SearchNotification
              cssClass={!flightTypeChange ? 'search__message_hidden' : ''}
              message={
                'Чартерные рейсы не найдены. Поиск запущен по всем типам рейсов.'
              }
            >
              <PiAirplaneTakeoffLight />
            </SearchNotification>
            <SearchNotification
              cssClass={!searchError ? 'search__message_hidden' : ''}
              message={searchErrorText}
            >
              <AiOutlineApi />
            </SearchNotification>
            <SearchNotification
              cssClass={!stopSearchNotification ? 'search__message_hidden' : ''}
              message={'Поиск по новым параметрам'}
            >
              <MdOutlineYoutubeSearchedFor />
            </SearchNotification>
          </div>
        )}

        {!this.state.startSearch ? (
          <div ref={this.toursRef} className="container tours tours-container">
            {hotelsForView ? (
              <HotelList
                departure={
                  this.state?.requestedDeparture ||
                  this.state?.request?.departure
                }
                request_model={this.state.request}
                recomend_hotels={recomend_hotels}
                geoclient={geoclient}
                onAction={this.handleGeoclientUpdate}
                onContinue={this.handleContinue}
                getHotelInfo={this.getHotelInfo}
                filteredOperators={filteredOperators}
                hotelsForView={hotelsForView}
                toursLength={data?.status?.toursfound}
                status={data.status?.progress}
                hotelsIdWithReviews={hotelsIdWithReviews}
              />
            ) : null}
            <div
              style={{
                width: '100%',
                textAlign: 'center',
                paddingBottom: '30px',
              }}
            >
              {data?.status?.hotelsfound > 3 ? (
                data.status?.progress !== 100 ||
                data.status.state === 'searching' ? (
                  <div style={{ padding: '20px' }}>
                    <ProgressBar
                      bgColor={'#DE4596'}
                      completed={
                        data.status.progress === 0 ? 5 : data.status.progress
                      }
                    />
                  </div>
                ) : this.state.moreButton ? (
                  <SearchTourMoreButton onContinue={this.handleContinue} />
                ) : null
              ) : this.state.moreButton ? (
                <SearchTourMoreButton onContinue={this.handleContinue} />
              ) : null}
            </div>
          </div>
        ) : (
          <div
            ref={this.toursRef}
            className="container tours"
            style={{ display: 'block' }}
          ></div>
        )}
        {showHotelInfo ? <HotelInfoView /> : null}
      </GeoclientContext.Provider>
    );
  }
}

const geoclient = (function () {
  const TOUR_KEY = 'tourStack';
  const TOURS_LIMIT = 20;
  const MESSAGE_DICT = {
    MAX_TOURS_LIMIT: `вы не можете добавить более ${TOURS_LIMIT} туров`,
    TOUR_ADD_SUCCESS: `тур успешно добавлен в подборку`,
    TOUR_REMOVE_SUCCESS: `тур удален из подборки`,
    TOUR_NOT_EXIST: `тур не найден`,
    TOUR_DUPLICATE: `тур уже есть в подборке`,
  };

  function getToursOrExists() {
    if (localStorage.getItem(TOUR_KEY)) {
      return JSON.parse(localStorage.getItem(TOUR_KEY));
    } else {
      return [];
    }
  }

  function findTour(id) {
    const TOURS = getToursOrExists();
    const tour = TOURS.find(function (t) {
      return +t.tour_id == +id;
    });
    return !!tour;
  }

  function init() {
    return sessionStorage.getItem('geoclient');
  }

  init();
  return {
    status: init(),
    /**
     * Проверка тура в подборке
     * @param tourId
     * @returns {boolean}
     */
    check: function (tourId) {
      if (!init()) {
        return false;
      }
      var tour = findTour(tourId);
      if (tour) {
        return true;
      } else {
        return false;
      }
    },
    /**
     * Добавить тур в подборку
     * @param tour
     */
    add: function (tour) {
      console.log('Добавить тур в подборку', tour);
      let TOURS = getToursOrExists();
      if (TOURS.length >= TOURS_LIMIT) {
        console.log(MESSAGE_DICT.MAX_TOURS_LIMIT);
        return false;
      }
      TOURS.push(this.normalize(tour));
      localStorage.setItem(TOUR_KEY, JSON.stringify(TOURS));
      return tour;
    },
    /**
     * Удалить тур из подборки
     * @param tour
     */
    remove: function (tourId) {
      console.log('Удалить тур из подборки', tourId);
      // var tours = JSON.parse(localStorage.getItem(TOUR_KEY));
      let TOURS = getToursOrExists();
      TOURS = TOURS.filter((t) => +tourId != +t.tour_id);
      localStorage.setItem(TOUR_KEY, JSON.stringify(TOURS));
      return true;
    },
    save: function (e) {
      let [form] = $('.geoclient-edit-tour__form');
      const [tour_id, manager_price, comment] = form;
      let TOURS = getToursOrExists();
      TOURS = TOURS.map((tour) => {
        if (tour.tour_id == tour_id.value) {
          tour.manager_data['comment'] = comment.value;
          tour.manager_data['initial_price'] = parseInt(manager_price.value);
        }
        return tour;
      });
      localStorage.setItem(TOUR_KEY, JSON.stringify(TOURS));
      $('.gt-popup__close').click();
    },
    normalize: function (tour) {
      return {
        tour_id: +tour.offer_id,
        country: tour.country_name,
        city_from: tour.depart_name,
        checkin: tour.dt1,
        nights: tour.nights,
        adults: tour.hotel_adult,
        children: tour.hotel_child,
        child_ages: tour.ages,
        resort: tour.town_name,
        name: tour.hotel_name + ' ' + tour.star_id,
        thumbnail: tour.hotel_image_src,
        operator: tour.oper_name,
        room: tour.room_name,
        board: tour.meal_full,
        initial_price: tour.price,
        currency: tour.currency,
        is_active: false,
        manager_data: {
          comment: '',
          adults: tour.adult,
          children: tour.child,
          child_ages: tour.ages,
          initial_price: '',
          discount: '',
          manager_id: '',
        },
      };
    },
  };
})();

export default SearchTourForm;
